import React from "react";
import { useState, useEffect } from "react";
import { ChevronDown } from "react-feather";
import { useIntl } from "react-intl";
import questionMap from "./questions";
import "./styles.scss";

const FAQ = () => {
  const { formatMessage, locale } = useIntl();
  const [openQuestions, setOpenQuestions] = useState([]);
  const [questions, setQuestions] = useState(questionMap[locale]);

  useEffect(() => {
    setQuestions(questionMap[locale]);
  }, [locale]);

  const toggleCollapse = id => {
    setOpenQuestions(questions =>
      questions.includes(id)
        ? questions.filter(questionId => questionId !== id)
        : [...questions, id]
    );
  };

  return (
    <>
      <h1>{formatMessage({ id: "perguntas-frequentes" })}</h1>

      <div className="content-box faq">
        {questions.map(section => (
          <>
            <h3>{section.name}</h3>
            {section.questions.map((question, index) => (
              <div
                className={`question-container${
                  !openQuestions.includes(`${section.name}-${index}`)
                    ? " collapsed"
                    : ""
                }`}
                key={`${section.name}-${index}`}
              >
                <div
                  className="question"
                  onClick={() => toggleCollapse(`${section.name}-${index}`)}
                >
                  <div>
                    <ChevronDown size="18px" />
                  </div>
                  <div>{question.question}</div>
                </div>
                <div className="answer">{question.answer}</div>
              </div>
            ))}
          </>
        ))}
      </div>
    </>
  );
};

export default FAQ;
